import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Effect from "./Effect";
import { FILTER_TYPES } from "../Constants";

var Filter =
/*#__PURE__*/
function (_Effect) {
  _inherits(Filter, _Effect);

  function Filter(context) {
    var _this;

    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FILTER_TYPES[0];
    var cutoff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
    var resonance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.9;

    _classCallCheck(this, Filter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Filter).call(this, context));
    _this.name = "filter";
    _this.effect.frequency.value = cutoff;
    _this.effect.Q.value = resonance;
    _this.effect.type = type;
    return _this;
  }

  _createClass(Filter, [{
    key: "setup",
    value: function setup() {
      this.effect = this.context.createBiquadFilter();
      this.effect.connect(this.output);
    }
  }]);

  return Filter;
}(Effect);

export { Filter as default };